let searchResultsComponent = {
    CUSTOM_BOUNDARIES: [
        {
            'name': 'berkshire',
            'entityType': 'AdminDivision2',
            'filename': 'berkshire.json'
        },
        {
            'name': 'bedfordshire',
            'entityType': 'AdminDivision2',
            'filename': 'bedfordshire.json'
        }
    ],
    ERROR_MSG: {
        noCoordinatesFound: 'No coordinates found',
        cannotGeocodeLocation: 'Unable to geocode location'
    },
    container: {},
    filterContainer: {},
    resultsContainer: {},
    mapContainer: {},
    searchLocation: {},
    searchFilters: {},
    priceFilter: {},
    typeFilter: {},
    bedroomFilter: {},
    searchBarActions: {}, // container for CTA buttons and hidden form fields
    map: {},
    microsoftMap: {},
    searchManager: {},
    searchPageState: {
        searchPrice: '',
        searchType: '',
        searchBedroom: '',
        searchLocationText: '',
        location: {
            latitude: 0,
            longitude: 0
        },
        boundaryEntityType: '',
        hasLocationBoundary: false
    },
    boundaryData: {},
    developmentsData: {},
    pins: [],
    developmentsTotal: 0,
    developmentsInside: 0,
    developmentListContainer: {},
    searchResultsInfo: {},
    searchResultMessageText: {
        multiDevelopmentAndProperty: '',
        multiDevelopmentSingleProperty: '',
        singleDevelopmentAndProperty: '',
        noDevelopmentsOrProperties: '',
    },
    loadSpin: {},
    init: function (container, bingAvailable) {
        this.container = container;
        if (bingAvailable) {
            this.mapContainer = document.getElementById('map');
            this.resultsContainer = this.container.querySelector('.search-results--wrap');

            this.filterContainer = this.container.querySelector('.search-bar--filters .search-bar');
            this.searchLocation = this.filterContainer.querySelector('.autocomplete--field');
            this.searchFilters = this.filterContainer.querySelectorAll('.search-filter');
            this.priceFilter = document.getElementById('search-filter--prices');
            this.typeFilter = document.getElementById('search-filter--types');
            this.bedroomFilter = document.getElementById('search-filter--bedrooms');

            this.searchBarActions = this.container.querySelector('.search-bar--actions');
            this.savedSearchPrice = this.searchBarActions.querySelector('.price-filter--initial');
            this.savedSearchType = this.searchBarActions.querySelector('.type-filter--initial');
            this.savedSearchBedroom = this.searchBarActions.querySelector('.bedroom-filter--initial');

            this.developmentListContainer = this.container.querySelector('.development-list--search');
            this.searchResultsInfo = this.container.querySelector('.search-bar--info');

            this.searchResultMessageText.multiDevelopmentAndProperty = container.querySelector('.devs-props').value;
            this.searchResultMessageText.multiDevelopmentSingleProperty = container.querySelector('.dev-props').value;
            this.searchResultMessageText.singleDevelopmentAndProperty = container.querySelector('.dev-prop').value;
            this.searchResultMessageText.noDevelopmentsOrProperties = container.querySelector('.empty-results').value;

            this.polygonStyle = {
                fillColor: 'rgba(216,131,144,0.4)',
                strokeColor: '#d10020',
                strokeThickness: 1,
            };

            this.createLoadingSpinner();
            this.showLoadingSpinner();

            resizeMapContainer();

            this.map = new Microsoft.Maps.Map('#map', {
                disableScrollWheelZoom: true,
                showMapTypeSelector: false,
            });


            this.microsoftMap = document.querySelector('.search-results--map .MicrosoftMap');

            this.getInitialSearchState();
            this.updateDisplayedFilters();

            if (this.microsoftMap) {
                document.addEventListener('click', function (e) {
                    if (e.target.hasAttribute('data-dev')) {
                        let triggerPin = {};
                        if (searchResultsComponent.map.entities.getPrimitives().length > 0) {
                            for (let i = 0; i < searchResultsComponent.map.entities.getPrimitives().length; i++) {
                                let entity = searchResultsComponent.map.entities.getPrimitives()[i];

                                if (entity.metadata !== undefined) {
                                    if (entity.metadata.href === e.target.getAttribute('data-dev')) {
                                        triggerPin.targetType = 'pushpin';
                                        triggerPin.target = entity;
                                        Microsoft.Maps.Events.invoke(entity, 'click', { target: entity }, searchResultsComponent.pushpinSearchClicked(triggerPin));
                                    }
                                }
                            }
                        }
                    }
                });

                window.addEventListener("popstate", (event) => {
          
                    let state = event.state;
                    
                    searchResultsComponent.searchLocation.value = state.searchLocationText;
                    searchResultsComponent.priceFilter.value = state.searchPrice;
                    searchResultsComponent.typeFilter.value = state.searchType;
                    searchResultsComponent.bedroomFilter.value = state.searchBedroom;
          
                    searchResultsComponent.searchPageState.searchPrice = state.searchPrice;
                    searchResultsComponent.searchPageState.searchType = state.searchType; 
                    searchResultsComponent.searchPageState.searchBedroom = state.searchBedroom;
          
                    searchResultsComponent.getSearchData().then((searchResults) => {
                        searchResultsComponent.displaySearchResults(searchResults, false);
                    });
                });
          

                //Load the Bing Spatial Data Services and Search modules, then create an instance of the search manager.
                Microsoft.Maps.loadModule(
                    [
                        'Microsoft.Maps.AutoSuggest',
                        'Microsoft.Maps.SpatialDataService',
                        'Microsoft.Maps.Search',
                        'Microsoft.Maps.SpatialMath',
                    ],
                    function () {
                        searchResultsComponent.searchManager = new Microsoft.Maps.Search.SearchManager(searchResultsComponent.map);
                        searchResultsComponent.displayLocationSearchResults();
                    }
                );

            } else {
                // handle no Bing
                handleNoBing();
            }

        }
        return;
    },
    getInitialSearchState: function () {
        this.searchPageState.searchPrice = this.filterContainer.querySelector('.price-filter--initial').value;
        this.searchPageState.searchType = this.filterContainer.querySelector('.type-filter--initial').value;
        this.searchPageState.searchBedroom = this.filterContainer.querySelector('.bedroom-filter--initial').value;
        this.searchPageState.searchLocationText = this.filterContainer.querySelector('.location-filter--initial').value;
    },
    updateSearchQueryString: function(isReplace) {
        let newQueryString = `${window.location.pathname}?location=${encodeURIComponent(this.searchPageState.searchLocationText)}&bedrooms=${this.searchPageState.searchBedroom}&propertyType=${this.searchPageState.searchType}&price=${this.searchPageState.searchPrice}`;
        if (isReplace) {
            window.history.replaceState(this.searchPageState, '', newQueryString);
        } else {
            window.history.pushState(this.searchPageState, '', newQueryString);
        }
    },
    updateDisplayedFilters: function () {
        this.searchLocation.value = this.searchPageState.searchLocationText;
        this.priceFilter.value = this.searchPageState.searchPrice;
        this.typeFilter.value = this.searchPageState.searchType;
        this.bedroomFilter.value = this.searchPageState.searchBedroom;
    },
    createLoadingSpinner: function () {
        this.loadSpin = document.createElement('div');
        this.loadSpin.classList = 'list-loader search-load';
    },
    showLoadingSpinner: function () {
        this.container.appendChild(this.loadSpin);
    },
    hideLoadingSpinner: function () {
        let loadSpinner = this.container.querySelector('.list-loader.search-load');
        if (loadSpinner) {
            this.container.removeChild(this.loadSpin);
        }
        this.resultsContainer.style.display = 'flex';
    },
    noResults: function () {
        this.mapContainer.classList.add('visible', 'no-result');
        this.microsoftMap.remove();
        this.resultsContainer.classList.add('no-results');
        setSearchResultsPageLayout({ 'data': { items: [] } });
        this.updateSearchResultsInfo(this.searchResultMessageText.noDevelopmentsOrProperties, true);
    },
    displayLocationSearchResults: function () {
        this.getLocationCoordinates().then((geocodeData) => {
            this.resultsContainer.style.display = 'none';
            let searchTerm = this.getBestSearchTerm(geocodeData);

            if (searchTerm) {

                this.searchPageState.boundaryEntityType = this.getEntityTypeFromSearchTerm(searchTerm);
                this.searchPageState.location.latitude = searchTerm.location.latitude;
                this.searchPageState.location.longitude = searchTerm.location.longitude;
                this.updateSearchQueryString(true);

                return this.getSearchBoundary(searchTerm);
            } else {
                throw new Error(this.ERROR_MSG.noCoordinatesFound);
            }
        }).then((boundary) => {
            this.searchPageState.hasLocationBoundary = true;
            this.boundaryData = boundary;
            this.searchPageState.boundaryEntityType = boundary.results[0].EntityMetadata.EntityType;

            this.resultsContainer.style.display = 'none';

            // set up the search fileters
            this.setupSearchFilters();

            this.getSearchData().then((searchResults) => {
                let isFirst = true;
                this.displaySearchResults(searchResults, isFirst);
                document.getElementById('map').classList.add('visible');
                // use Microsoft.Maps.LocationRect.fromShapes with the polygonal data from the query to set the view
                this.map.setView({ bounds: Microsoft.Maps.LocationRect.fromShapes(this.boundaryData.results[0].Polygons) });

            });

        }).catch((error) => {
            this.hideLoadingSpinner();
            if (error.message === this.ERROR_MSG.noCoordinatesFound ) {
                this.noResults();
            } else {
                // otherwise we found the location but not a boundary - this is a Bing error
                handleBingError(error);
            }
        });
    },
    getLocationCoordinates: function () {
        return new Promise((resolve, reject) => {

            // check here for coords and entityType supplied as search params (from Saved Search or A;lerts Email)
            const url = new URL(window.location);
            const searchParams = new URLSearchParams(url.search);
            this.searchPageState.location.latitude = searchParams.get('latitude');
            this.searchPageState.location.longitude = searchParams.get('longitude');
            this.searchPageState.boundaryEntityType = searchParams.get('boundaryEntityType');

            // note for UK longitude can be 0
            if (this.searchPageState.location.latitude > 0 && this.searchPageState.boundaryEntityType.length > 0) {
                this.searchPageState.searchLocationText = searchParams.get('location');
                // put data in structure returned by Geocoder
                let geocodeResult = {
                    results: [
                        {
                            name: this.searchPageState.searchLocationText,
                            address: {
                                countryRegionISO2: 'GB'
                            },
                            entityType: this.searchPageState.boundaryEntityType,
                            location: {
                                latitude: this.searchPageState.location.latitude,
                                longitude: this.searchPageState.location.longitude
                            }
                        }
                    ]
                };
                this.updateSearchQueryString(true);
                resolve(geocodeResult);

            } else {
                let geocodeRequest = {
                    where: searchResultsComponent.searchPageState.searchLocationText,
                    includeCountryIso2: true,
                    callback: function (geocodeData) {
                        // The fulfillment value of the promise
                        resolve(geocodeData);
                    },
                    errorCallback: function (error) {
                        reject(new Error(searchResultsComponent.ERROR_MSG.cannotGeocodeLocation));
                    }
                };
                searchResultsComponent.searchManager.geocode(geocodeRequest);

            }
        });
    },
    getBestSearchTerm: function (geocodeResult) {
        let searchTerm;
        let searchList = [];
        if (geocodeResult && geocodeResult.results && geocodeResult.results.length > 0) {
            for (i = 0; i < geocodeResult.results.length; i++) {
                if (geocodeResult.results[i].address.countryRegionISO2 === 'GB') {
                    if (geocodeResult.results[i].entityType === 'AdminDivision2') {
                        searchList.unshift(geocodeResult.results[i]);
                    } else {
                        searchList.push(geocodeResult.results[i]);
                    }
                }
            }
            searchTerm = searchList[0];
        }

        return searchTerm;

    },
    getEntityTypeFromSearchTerm: function (searchTerm) {
        let entityType;

        switch (searchTerm.entityType) {
            case 'CountryRegion':
            case 'AdminDivision1':
            case 'AdminDivision2':
            case 'Postcode2':
            case 'Postcode3':
            case 'Postcode4':
                entityType = searchTerm.entityType;
                break;
            case 'PopulatedPlace':
                // If it's Greater London then use the Administrative boundary
                if (searchTerm.address.district === 'Greater London' && searchTerm.address.locality === 'London') {
                    entityType = 'AdminDivision2';
                    // Else for London areas use the Postal District
                } else if ((searchTerm.address.district === 'London' || searchTerm.address.district === 'Greater London') && searchTerm.address.locality !== 'London') {
                    entityType = 'Postcode3';
                } else if (searchTerm.address.locality === 'Ascot' && searchTerm.address.district === 'Windsor and Maidenhead') {
                    entityType = 'Postcode3';
                } else if (searchTerm.address.locality === 'Birmingham' && searchTerm.address.district === 'West Midlands') {
                    entityType = 'AdminDivision3';
                } else {
                    entityType = searchTerm.entityType;
                }
                break;
            default:
                entityType = 'Postcode3';
        }

        return entityType;

    },
    getSearchBoundary: function (searchTerm) {
        return new Promise((resolve, reject) => {
            let geoDataRequestOptions = {
                lod: 1,
                getEntityMetadata: true,
                entityType: this.searchPageState.boundaryEntityType
            };

            if (this.checkForCustomBoundary(searchTerm)) {
                this.getCustomBoundary(searchTerm, this.polygonStyle).then(boundary => {
                    let boundaryData = {
                        'results': [{
                            'Polygons': [boundary],
                            'EntityMetadata': {
                                'EntityType': geoDataRequestOptions.entityType
                            }
                        }],
                    };
                    resolve(boundaryData);
                });
            } else {
                try {
                    let searchComponent = this;

                    Microsoft.Maps.SpatialDataService.GeoDataAPIManager.getBoundary(
                        searchTerm.location,
                        geoDataRequestOptions,
                        this.map,
                        function (boundaryData) {
                            if (boundaryData.results && boundaryData.results.length > 0) {
                                resolve(boundaryData);
                            } else if (geoDataRequestOptions.entityType !== 'Postcode3') {
                                searchComponent.searchPageState.boundaryEntityType = 'Postcode3';
                                searchComponent.getSearchBoundary(searchTerm)
                                    .then((boundaryData) => {
                                        resolve(boundaryData);
                                    });

                            } else {
                                reject('No boundary data found');
                            }
                        },
                        this.polygonStyle);
                } catch (error) {
                    reject(error);
                }
            }
        });
    },
    checkForCustomBoundary: function (searchTerm) {
        let customBoundaryExists = false;
        const TYPECHECK = /AdminDivision[12]/;
        if (TYPECHECK.test(searchTerm.entityType)) {
            if (typeof this.CUSTOM_BOUNDARIES.find((county) => county.name === searchTerm.name.split(',')[0].toLowerCase()) !== 'undefined') {
                customBoundaryExists = true;
            }
        }
        return customBoundaryExists;
    },
    getCustomBoundaryDefinition: function (searchTerm) {
        let customBoundary = this.CUSTOM_BOUNDARIES.find((county) => county.name === searchTerm.name.split(',')[0].toLowerCase());
        if (typeof customBoundary === 'undefined') {
            customBoundary = { 'name': '', 'entityType': '', 'filename': '' };
        }
        return customBoundary;
    },
    getCustomBoundary: async function (searchTerm) {
        try {
            let boundaryFilename = this.getCustomBoundaryDefinition(searchTerm).filename;
            if (boundaryFilename !== '') {
                let infoResponse = await fetch(
                    `/assets/boundaries/${boundaryFilename}`
                );
                if (infoResponse.status == 200) {
                    let boundaryData = await infoResponse.json();
                    let coords = [];
                    boundaryData.polygon.forEach((point) => {
                        coords.push(new Microsoft.Maps.Location(point[1], point[0]));
                    });

                    //Create a boundary polygon
                    let boundary = new Microsoft.Maps.Polygon(coords, this.polygonStyle);

                    return boundary;
                } else {
                    throw new Error(response.status);
                }
            }
        } catch (error) {
            console.log(error);
        }
    },

    setupSearchFilters: function () {
        this.searchFilters.forEach(function (filter) {
            filter.addEventListener('change', function (e) {

                // Update the state and the CTA (Saved Search) form field
                if (searchResultsComponent.searchBarActions) {
                    if (filter.id === 'search-filter--prices') {
                        searchResultsComponent.searchPageState.searchPrice = searchResultsComponent.priceFilter.value;
                        searchResultsComponent.savedSearchPrice.value = searchResultsComponent.searchPageState.searchPrice;
                    }
                    if (filter.id === 'search-filter--types') {
                        searchResultsComponent.searchPageState.searchType = searchResultsComponent.typeFilter.value;
                        searchResultsComponent.savedSearchType.value = searchResultsComponent.searchPageState.searchType;
                    }
                    if (filter.id === 'search-filter--bedrooms') {
                        searchResultsComponent.searchPageState.searchBedroom = searchResultsComponent.bedroomFilter.value;
                        searchResultsComponent.savedSearchBedroom.value = searchResultsComponent.searchPageState.searchBedroom;
                    }
                }
                // update the query string but do not replace the state
                searchResultsComponent.updateSearchQueryString(false);
                searchResultsComponent.developmentListContainer.innerHTML = '';
                searchResultsComponent.removePins();

                searchResultsComponent.getSearchData().then((searchResults) => {
                    searchResultsComponent.displaySearchResults(searchResults, false);
                });
            });
        });
    },
    getSearchData: async function () {

        if (this.searchPageState.hasLocationBoundary) {

            try {
                let devListURL = this.getDevelopmentListAPIUrl();
                return this.getDevelopmentSearchResults(devListURL);

            } catch (error) {
                console.log(error);
            }

        } else {
            console.log('No boundary data: Search data not displayed');
        }
    },
    getDevelopmentListAPIUrl: function () {
        const API = `${APIPrefix.get()}/search_api/developmentsresults/list/?`;
        const paramsObj = {
            price: this.searchPageState.searchPrice,
            propertyType: this.searchPageState.searchType,
            bedrooms: this.searchPageState.searchBedroom,
            location: this.searchPageState.searchLocationText,
            latitude: parseFloat(this.searchPageState.location.latitude).toFixed(6),
            longitude: parseFloat(this.searchPageState.location.longitude).toFixed(6),
            boundaryEntityType: this.searchPageState.boundaryEntityType,
            hasLocBoundary: this.searchPageState.hasLocationBoundary
        };
        const searchParams = new URLSearchParams(paramsObj);

        return API + searchParams.toString();
    },
    getDevelopmentSearchResults: async function (devListAPIUrl) {
        let response = await fetch(devListAPIUrl);
        if (response.status == 200) {
            let data = await response.json();
            return data;
        } else {
            throw new Error(response.status);
        }
    },
    displaySearchResults: function (searchResults, isFirst) {
        this.developmentsData = searchResults;

        this.createPinsAndText(isFirst);
        if (isFirst) {
            this.hideLoadingSpinner();
        }
        const createAlertButton = this.searchBarActions.querySelector('.alert-cta');
        const saveSearchButton = this.searchBarActions.querySelector('.save-cta');

        this.setSaveAndAlertButtonState(searchResults.data.configuration, saveSearchButton, createAlertButton);
        this.setSearchResultsPageLayout(searchResults);
    },
    createPinsAndText: function (first) {
        const PIN_NORMAL = this.developmentsData.data.configuration.normalIconPin;
        const developments = this.developmentsData.data.items;

        let devsProps;
        let devProp;
        let pin;

        let locations = [];
        let polygon;
        let developmentsInsideBoundary = [];
        let developmentsOutsideBoundary = [];
        let boundaryExists;
        if (first) {
            polygon = this.boundaryData.results[0].Polygons[0];
        } else {
            polygon = this.map.entities.getPrimitives()[0];
        }
        let polygonCentroid = Microsoft.Maps.SpatialMath.Geometry.centroid(polygon);
        this.map.entities.clear();
        this.map.entities.push(polygon);
        for (const items in developments) {
            const PLACE = developments[items].developmentCoordinates;
            pin = new Microsoft.Maps.Pushpin(new Microsoft.Maps.Location(PLACE.latitude, PLACE.longitude), {
                icon: PIN_NORMAL,
            });
            pin.metadata = {
                href: developments[items].developmentId,
            };
            this.pins.push(pin);
            this.map.entities.push(pin);
            var IsInPolygon = Microsoft.Maps.SpatialMath.Geometry.contains(polygon, pin);

            if (IsInPolygon) {
                this.developmentsInside += 1;
                this.developmentsTotal += developments[items].developmentNoOfProperties;
                // get distance from development to Centre of boundary
                developments[items].distanceToCentroid = Microsoft.Maps.SpatialMath.Geometry.distance(polygonCentroid, pin, Microsoft.Maps.SpatialMath.DistanceUnits.Meters, false);
                locations.push(this.developmentsInside);
                developmentsInsideBoundary.push(developments[items]);
            } else {
                // Get distance from development to boundary
                developments[items].distOutside = Microsoft.Maps.SpatialMath.Geometry.distance(polygon, pin, Microsoft.Maps.SpatialMath.DistanceUnits.Meters, false);
                developmentsOutsideBoundary.push(developments[items]);
                devsProps = this.searchResultMessageText.multiDevelopmentAndProperty.replace('{0}', this.developmentsInside).replace('{1}', this.developmentsTotal);
                this.updateSearchResultsInfo(devsProps, false);
            }

            if (this.developmentsInside > 1 && this.developmentsTotal > 1) {
                devsProps = this.searchResultMessageText.multiDevelopmentAndProperty.replace('{0}', this.developmentsInside).replace('{1}', this.developmentsTotal);
                this.searchResultsInfo.innerHTML = devsProps;
            }

            if (this.developmentsInside == 1 && this.developmentsTotal > 1) {
                devProp = this.searchResultMessageText.multiDevelopmentSingleProperty.replace('{1}', this.developmentsTotal);
                this.searchResultsInfo.innerHTML = devProp;
            }

            if (this.developmentsInside == 1 && this.developmentsTotal == 1) {
                this.searchResultsInfo.innerHTML = this.searchResultMessageText.singleDevelopmentAndProperty;
            }

            this.searchResultsInfo.classList.add('show');
            Microsoft.Maps.Events.addHandler(pin, 'click', this.pushpinSearchClicked);
        }
        // Sort developments by distannce to centroid/boundary
        developmentsInsideBoundary.sort((a, b) => a.distanceToCentroid - b.distanceToCentroid);
        developmentsOutsideBoundary.sort((a, b) => a.distOutside - b.distOutside);
        if (polygon !== undefined) {
            boundaryExists = true;
        } else {
            boundaryExists = false;
        }
        this.createDevContainers(
            boundaryExists,
            developments,
            developmentsInsideBoundary,
            developmentsOutsideBoundary,
            this.developmentListContainer
        );

        // reset counters in case filters change
        this.developmentsInside = 0;
        this.developmentsTotal = 0;

        if (locations.length === 0) {
            this.updateSearchResultsInfo(this.searchResultMessageText.noDevelopmentsOrProperties, true);
        }
    },
    removePins: function () {
        let primitives = this.map.entities.getPrimitives();
        let removedPins = [];
        for (const item in primitives) {
            let entity = primitives[item].entity.id;
            if (entity.includes('Pushpin')) {
                removedPins.push(primitives[item]);
            }
        }
        for (const item in removedPins) {
            this.map.entities.remove(removedPins[item]);
        }
    },
    pushpinSearchClicked: function (e) {
        const PIN_NORMAL = searchResultsComponent.developmentsData.data.configuration.normalIconPin;
        const PIN_HOVER = searchResultsComponent.developmentsData.data.configuration.hoverIconPin;
        if (e.targetType == 'pushpin') {
            let selectedPin = e.target;
            const ANCHOR = document.getElementById('#' + selectedPin.metadata.href);
            const TARGET = document.querySelector('.search-results--list');
            //We make it so only one pin is highlited at one time
            if (selectedPin._options.icon.includes('normal')) {
                for (const pin in searchResultsComponent.pins) {
                    searchResultsComponent.pins[pin].setOptions({ icon: PIN_NORMAL });
                }
                selectedPin.setOptions({ icon: PIN_HOVER });
                TARGET.scrollTop = ANCHOR.offsetTop - 10;
            } else {
                selectedPin.setOptions({ icon: PIN_NORMAL });
            }
        }
    },
    createDevContainers: function (hasBoundary, allData, insideData, outsideData, list) {
        const OUTSIDE_DELIMITER = document.querySelector('.outside-delimiter').value;
        if (hasBoundary) {
            if (insideData.length > 0) {
                this.devContainerHTML(insideData, list);
            }
            if (outsideData.length > 0) {
                const LI = document.createElement('li');
                LI.innerHTML = `<h3>${OUTSIDE_DELIMITER}</h3>`;
                LI.classList.add('delimiter');
                list.appendChild(LI);
                this.devContainerHTML(outsideData, list);
            }
        } else {
            const LI = document.createElement('li');
            LI.innerHTML = `<h3>${OUTSIDE_DELIMITER}</h3>`;
            LI.classList.add('delimiter');
            list.appendChild(LI);
            this.devContainerHTML(allData, list);
        }
    },
    devContainerHTML: function (containerData, thelist) {
        for (const details in containerData) {
            const LI = document.createElement('li');
            const DIV = document.createElement('div');
            const ID = containerData[details].developmentId;
            let markup = `<a id="#${ID}"></a><div class="list-loader"></div>`;
            let observer;
            let options = {
                root: null,
                rootMargin: '0px',
                threshold: 0.2,
            };
            DIV.setAttribute('data-id', ID);
            DIV.classList.add('wrapper');
            DIV.id = ID;
            DIV.innerHTML = markup;
            thelist.appendChild(LI);
            LI.appendChild(DIV);
            observer = new IntersectionObserver(this.handleSearchIntersect, options);
            observer.observe(DIV);
        }
    },
    handleSearchIntersect: function (entries, observer) {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                let data_ID = entry.target.dataset.id;
                const developmentDiv = entry.target; //the div that is visible in viewport

                async function getSearchInfo() {
                    try {
                        let DEVELOPMENT_STATUS_VALUE = '';
                        let infoResponse = await fetch(
                            `${APIPrefix.get()}/search_api/developments/details?developmentId=${data_ID}&status=${DEVELOPMENT_STATUS_VALUE}`
                        );
                        if (infoResponse.status == 200) {
                            let info = await infoResponse.json();
                            return info;
                        } else {
                            throw new Error(response.status);
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }

                // Get the development details
                getSearchInfo().then((info) => {
                    let itemsInfo = info.data;
                    let devId = developmentDiv.getAttribute('data-id');
                    const NP = document.querySelector('.num-of-props').value;
                    const NO_OF_PROP = document.querySelector('.num-of-prop').value;
                    let numberOfProperties;
                    for (const item in searchResultsComponent.developmentsData.data.items) {
                        if (searchResultsComponent.developmentsData.data.items[item].developmentId === devId) {
                            numberOfProperties = searchResultsComponent.developmentsData.data.items[item].developmentNoOfProperties;
                        }
                    }

                    const NO_OF_PROPS = NP.replace('{0}', numberOfProperties);
                    developmentDiv.innerHTML = getSearchListDevelopmentHTML(devId, itemsInfo, numberOfProperties, NO_OF_PROPS, NO_OF_PROP);

                    let wrap = developmentDiv.querySelector('.table-results-wrapper');
                    let btn = developmentDiv.querySelector('.prop-table');
                    if (btn) {
                        // get the Development Property data
                        let isFirst = true;
                        searchResultsComponent.getSearchTableData(developmentDiv, isFirst).then((data) => {
                            if (data.data.items.length) {
                                searchResultsComponent.buildDevelopmentPropertyTable(developmentDiv, data.data);
                            }
                        });
                        tableUtils.initShowPropertiesButton(wrap, btn);
                    }
                });
            }
        }
    },
    setSaveAndAlertButtonState: function (searchResultsConfig, saveButton, alertButton) {
        let searchWasSaved = searchResultsConfig.searchItemWasSaved;
        let searchHasAlert = searchResultsConfig.searchItemHasAlert;

        // Buttons may be disabled (eg: C360 down)
        if (saveButton == null || alertButton == null) {
            return false;
        }

        if (searchWasSaved) {
            if (searchHasAlert) {

                // Already has saved alert: cannot save or create an alert
                this.disableButton(saveButton);
                this.disableButton(alertButton);
            } else {

                // Saved with no alert: can create an alert but not save
                this.disableButton(saveButton);
                this.enableButton(alertButton);
            }
        } else {

            // Not saved so can save or create an alert
            this.enableButton(saveButton);
            this.enableButton(alertButton);
        }
    },
    setSearchResultsPageLayout: function (devData) {
        let noResultsWrap = document.querySelector('.search-no-results');
        let mapElement = document.querySelector('#map');
        let searchResList = document.querySelector('.search-results--list');
        let searchResWrap = document.querySelector('.search-results--wrap');

        if (devData.data.items.length === 0) {
            noResultsWrap.style.display = 'block';
            noResultsWrap.style.visibility = 'visible';
            noResultsWrap.style.position = 'relative';
            mapElement.style.display = 'none';
            searchResList.style.display = 'none';
            searchResWrap.classList.add('no-results');
            searchResWrap.removeAttribute('style');
            window.removeEventListener('resize', resizeMapContainer);
            windowUtils.removeOrientationListener(resizeMapContainer);
        } else {
            noResultsWrap.style.display = 'none';
            noResultsWrap.style.visibility = 'hidden';
            noResultsWrap.style.position = 'relative';
            mapElement.style.display = 'block';
            searchResList.style.display = 'block';
            // set up event handlers to make sure map sizes correctly
            resizeMapContainer();
            window.addEventListener('resize', resizeMapContainer, { passive: true });
            windowUtils.addOrientationListener(resizeMapContainer);
        }
    },
    disableButton: function (button) {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('type', 'button');
        button.classList.add('disabled');
        return true;
    },

    enableButton: function (button) {
        button.setAttribute('aria-disabled', 'false');
        button.setAttribute('type', 'submit');
        button.classList.remove('disabled');
        this.setSaveAndAlertButtonsDisabledAfter(button);
        return true;
    },
    // Disable save + alert buttons after actioned
    setSaveAndAlertButtonsDisabledAfter: function (ctaButton) {
        ctaButton.onclick = function () {
            ctaButton.classList.add('disabled');
            setTimeout(function () { 
                ctaButton.setAttribute('aria-disabled', 'true');
                ctaButton.setAttribute('type', 'button');
            }, 0);
            return true;
        };
    },
    // Get Development Properties
    getSearchTableData: async function (developmentDiv, isFirst) {
        const API = `${APIPrefix.get()}/search_api/properties`;
        if (isFirst) {
            const PRICE = this.searchPageState.searchPrice;
            const TYPE = this.searchPageState.searchType;
            const BEDROOM = this.searchPageState.searchBedroom;
            try {
                const NUMB_PER_PAGE = document.querySelector('.num-per-page').value;
                let DEVELOPMENT_STATUS_VALUE = '';
                let response = await fetch(
                    `${API}?noOfItemsPerPage=${NUMB_PER_PAGE}&dataSourcePageId=${developmentDiv.id
                    }&status=${DEVELOPMENT_STATUS_VALUE}&selectedPrice=${encodeURIComponent(
                        PRICE
                    )}&selectedPropertyType=${TYPE}&selectedNoOfBedrooms=${BEDROOM}`
                );
                if (response.status == 200) {
                    let data = await response.json();
                    return data;
                } else {
                    throw new Error(response.status);
                }
            } catch (error) {
                console.log(error);
            }
        } else {
            let priceSelected = priceFilter.options[priceFilter.selectedIndex].value;
            let typeSelected = typeFilter.options[typeFilter.selectedIndex].value;
            let bedroomSelected = bedroomFilter.options[bedroomFilter.selectedIndex].value;
            try {
                const NUMB_PER_PAGE = document.querySelector('.num-per-page').value;
                let DEVELOPMENT_STATUS_VALUE = '';
                let response = await fetch(
                    `${API}?noOfItemsPerPage=${NUMB_PER_PAGE}&dataSourcePageId=${developmentDiv.id
                    }&status=${DEVELOPMENT_STATUS_VALUE}&selectedPrice=${encodeURIComponent(
                        priceSelected
                    )}&selectedPropertyType=${typeSelected}&selectedNoOfBedrooms=${bedroomSelected}`
                );
                if (response.status == 200) {
                    let data = await response.json();
                    return data;
                } else {
                    throw new Error(response.status);
                }
            } catch (error) {
                console.log(error);
            }
        }
    },
    buildDevelopmentPropertyTable: function (developmentDiv, propertyData) {

        const HEADINGS = propertyData.headings;
        const ITEMS = propertyData.items;
        const CONFIGURATION = propertyData.configuration;
        let wrap = developmentDiv.querySelector('.table-results-wrapper');
        const PROP_LIST_TAB = wrap.querySelector('.property-list-component');
        const TABLE_WRAPPER = wrap.querySelector('.property-list-component .table-wrapper');
        const TABLE = document.createElement('table');
        TABLE.setAttribute('class', 'pagination');
        TABLE_WRAPPER.appendChild(TABLE);
        PROP_LIST_TAB.appendChild(TABLE_WRAPPER);
        for (const field in propertyData) {
            const THEAD = document.createElement('thead');
            const TABLE_ROW = document.createElement('tr');
            THEAD.appendChild(TABLE_ROW);
            const TBODY = document.createElement('tbody');
            if (field == 'headings') {
                for (const child in HEADINGS) {
                    const HEADER_CELL = document.createElement('th');
                    TABLE_ROW.appendChild(HEADER_CELL);
                    HEADER_CELL.innerText = HEADINGS[child];
                    TABLE.appendChild(THEAD);
                }
                const HEADER_CELL = document.createElement('th');
                HEADER_CELL.classList.add('disabled-sorting');
                TABLE_ROW.appendChild(HEADER_CELL);
                TABLE.appendChild(THEAD);
            } else if (field == 'items') {
                for (const child in ITEMS) {
                    const TABLE_ROW = document.createElement('tr');
                    let item = ITEMS[child].fields;
                    let btn = ITEMS[child].button;
                    for (const row in item) {
                        const TABLE_DATA = document.createElement('td');
                        TABLE_ROW.appendChild(TABLE_DATA);
                        if (row === 'propertynumber') {
                            if (btn.url !== '') {
                                TABLE_DATA.innerHTML = `<a class="link--default" href="${btn.url}" title="${btn.tooltip}">${item[row]}</a>`;
                            } else {
                                TABLE_DATA.innerText = item[row];
                            }
                        } else {
                            TABLE_DATA.innerText = item[row];
                        }
                        TBODY.appendChild(TABLE_ROW);
                        TABLE.appendChild(TBODY);
                    }
                    if (btn.url !== '') {
                        let link = document.createElement('a');
                        link.setAttribute('href', btn.url);
                        link.innerHTML = btn.name;
                        link.setAttribute('class', 'button button--primary');
                        link.setAttribute('title', btn.name);
                        let NEW_CELL = TABLE_ROW.insertCell(-1);
                        NEW_CELL.appendChild(link);
                    } else {
                        let link = document.createElement('span');
                        link.innerHTML = 'Reserved';
                        let NEW_CELL = TABLE_ROW.insertCell(-1);
                        NEW_CELL.appendChild(link);
                    }
                }
            }
        }

        if (ITEMS !== undefined && ITEMS.length !== 0) {
            let dataTable = tableUtils.initPaginatedDataTable(developmentDiv, CONFIGURATION, true, true);

            let paginationWrapper = developmentDiv.querySelector('.dataTable-pagination');
            if (paginationWrapper && paginationWrapper.hasChildNodes()) {
                tableUtils.initPaginationControlStates(dataTable, paginationWrapper);
                tableUtils.displayFirstPageAfterSort(dataTable, developmentDiv);
            }
        }
    },
    updateSearchResultsInfo: function (message, showInfo) {
        this.searchResultsInfo.innerHTML = message;
        if (showInfo) {
            this.searchResultsInfo.classList.add('show');
        }
    }

};